import React, { useEffect, useMemo, useState } from "react";
import DataTable from 'react-data-table-component'
import SubHeader from '../../../../../component/common/layout/SubHeader'
import SurveyListHeader from '../../../../../component/common/layout/SurveyListHeader'
import SurveyListSidebar from '../../../../../component/common/layout/SurveyListSidebar'
import VariableSidebar from '../../../../../component/common/layout/VariableSidebar'
import Card from "../../../../../core/Card";
import style from "../../../../style.module.css";
import Input from "../../../../../core/Inputs/DefaultInput";
import Svg from '../../../../../component/common/Svg'
import Typography from "../../../../../core/Typography";
import { useDevice } from "../../../../customHooks";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Link } from "react-router-dom";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useVerifySurveyId } from "../../../../../hooks";
import { addStage, deleteStage, getCustomFormula, getCustomVariable, getStages, updateStage } from "../../../../../store/actions/variableAction";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { getTokenData } from "../../../../../store/actions/authAction";
import NestedMenuToggle from "../../../settings/NestedMenuToggle";
import { useTranslation } from 'react-i18next';


export default function Stages() {
    //==> STATES <==

    //Modal
    const [isVisibleModal, setIsVisibleModal] = useState(false)
    const [isEditMode, setIsEditMode] = useState(false)
    const [userId, setuserId] = useState('')
    const [currentlyEditingStage, setCurrentlyEditingStage] = useState(null)
    const [currentlyDeleting, setCurrentlyDeleting] = useState(null)
    const [currentlyDeletingStageName, setCurrentlyDeletingStageName] = useState(null)

    //Selectors
    const customFormulas = useSelector((state) => state.variables?.customFormulaData)
    const customVariables = useSelector((state) => state.variables?.customVariableData)
    const stages = useSelector((state) => state.variables?.stageData)
    const { survey_name } = useSelector((state) => state.permissionsData)

    //Others
    let device = useDevice()
    const dispatch = useDispatch()
    const survey_id = useVerifySurveyId()
    const language_code = '22'
    const { t, i18n } = useTranslation();

    //Options
    const rangeModeOptions = [
        {
            name: 'Between',
            value: 'between'
        },
        {
            name: 'From',
            value: 'from'
        }
    ]

    //Columns
    const columns = [
        {
            name: t('survey.stages.stagesName'),
            cell: (row, index) => {
                let name = row.su_stage_name && JSON.parse(row.su_stage_name)
                name = name && name[language_code]
                return (
                    <>
                        <span title={name}>{name}</span>
                    </>
                )
            },
            sortable: true,
            sortFunction: (a, b) => {
                let a1 = a.su_stage_name && JSON.parse(a.su_stage_name)
                a1 = a1 && a1[language_code]
                let b1 = b.su_stage_name && JSON.parse(b.su_stage_name)
                b1 = b1 && b1[language_code]
                return sortString(a1, b1)
            }
        },
        {
            name: t('survey.stages.add_Date'),
            cell: (row, index) => {
                const date = row?.su_add_date_time
                let formattedToday = ''
                if (date) {
                    let addedDate = new Date(date)
                    const yyyy = addedDate.getFullYear();
                    let mm = addedDate.getMonth() + 1;
                    let dd = addedDate.getDate();

                    if (dd < 10) dd = '0' + dd;
                    if (mm < 10) mm = '0' + mm;

                    formattedToday = dd + '/' + mm + '/' + yyyy;
                }
                return (<>
                    <span>{formattedToday}</span>
                </>)
            },
            sortable: true,
            sortFunction: (a, b) => {
                let a1 = a?.su_add_date_time
                let b1 = b?.su_add_date_time
                a1 = new Date(a1)
                b1 = new Date(b1)

                if (a1 > b1) {
                    return 1;
                }
                if (b1 > a1) {
                    return -1;
                }
                return 0;

            }
        },
        {
            name: t('survey.customVariable.action'),
            cell: (row, index) => <>
                <div className="d-flex action-buttons">
                    {window.modulePermissions.M15.edit == 1 && (<button title='Edit' className="action-btn" onClick={() => handleEdit(row)}>
                        <Svg name="table-edit" />
                    </button>)}
                    {window.modulePermissions.M15.del == 1 && (
                    <button title='Delete' onClick={() => handleDeleteModal(row)} className="action-btn" data-bs-toggle="modal" data-bs-target="#deleteStageModal">
                        <Svg name="table-delete" />
                    </button>
                    )}
                </div>
            </>
        }
    ]


    //==> FORM SCHEMA AND VALIDATION <==

    //Yup
    const formSchema = Yup.object().shape({
        stageName: Yup.string().trim().required('Stage name required'),
        formula: Yup.string().trim().required('Please select formula'),
        rangeMode: Yup.string().trim().required('Please select rage type'),
        rangeStart: Yup.string().trim().required('Please enter starting range'),
        rangeEnd: Yup.string().trim().required('Please enter ending range'),
        assign: Yup.array().of(
            Yup.object().shape({
                key: Yup.string().required("Variable required"),
                value: Yup.string().required("Values required")
            })
        )
    })

    //Formik
    const initialValues = {
        stageName: '',
        formula: '',
        rangeMode: '',
        rangeStart: '',
        rangeEnd: '',
        assign: [{
            key: '',
            value: ''
        }],
    }

    const initialErrors = {
        stageName: '',
        formula: '',
        rangeMode: '',
        rangeStart: '',
        rangeEnd: '',
        assign: [{
            key: '',
            value: ''
        }],
    }

    const initialTouched = {
        stageName: false,
        formula: false,
        rangeMode: false,
        rangeStart: false,
        rangeEnd: false,
        assign: [{
            key: false,
            value: false
        }],
    }

    const formik = useFormik({
        initialValues: initialValues,
        initialTouched: initialTouched,
        initialErrors: initialErrors,
        validationSchema: formSchema,
        onSubmit: (data) => {
            if (!isEditMode) {
                handleAddStage(data)
            }
            else {
                handleUpdateStage(data)
            }
        }
    })

    const { values, handleChange, handleBlur, touched, errors, resetForm, setFieldValue, setFieldTouched, setFieldError, handleSubmit, setValues } = formik

    const canMutate = isEditMode ? window.modulePermissions.M15.edit == 1 : window.modulePermissions.M15.add == 1

    //==> FUNCTIONALITIES <==
    //Modal
    const resetModal = () => {
        setIsVisibleModal(false)
        setIsEditMode(false)
        setCurrentlyEditingStage(null)
        resetForm()
    }

    //Submit methods
    const handleAddStage = (data) => {
        const payload = {
            user: userId,
            survey_id: survey_id,
            language_code: language_code,
            stageName: data.stageName,
            stageFormulas: {
                compare: data.formula,
                type: data.rangeMode,
                from: data.rangeStart,
                to: data.rangeEnd,
                assign: data.assign,
            }
        }
        dispatch(addStage(payload, afterAddAndEdit))
    }

    const handleUpdateStage = (data) => {
        const payload = {
            stageId: currentlyEditingStage,
            language_code: language_code,
            stageName: data.stageName,
            stageFormulas: {
                compare: data.formula,
                type: data.rangeMode,
                from: data.rangeStart,
                to: data.rangeEnd,
                assign: data.assign,
            }
        }
        dispatch(updateStage(payload, afterAddAndEdit))
    }

    //Data handling
    const fetchFormula = async () => {
        dispatch(getCustomFormula(survey_id))
    }

    const fetchCustomVariable = async () => {
        dispatch(getCustomVariable(survey_id))
    }

    const fetchStages = () => {
        const payload = {
            survey_id
        }
        dispatch(getStages(payload))
    }

    const handleEdit = (data) => {
        const { su_survey_stages_id: stageId, su_stage_name: name, su_stage_formulas: formulas } = data
        if (stageId && name && formulas) {
            const stageName = name && JSON.parse(name)[language_code]
            const formattedData = JSON.parse(formulas)

            let tmpAssign = formattedData.assign
            if (tmpAssign && !Array.isArray(tmpAssign)) {
                if (Object.keys(tmpAssign).length > 0) {
                    tmpAssign = Object.keys(tmpAssign)?.map((key) => tmpAssign[key])
                } else {
                    tmpAssign = []
                }
            }

            const values = {
                stageName: stageName,
                formula: formattedData.compare,
                rangeMode: formattedData.type,
                rangeStart: formattedData.from,
                rangeEnd: formattedData.to,
                assign: tmpAssign,
            }
            setCurrentlyEditingStage(stageId)
            setIsEditMode(true)
            setIsVisibleModal(true)
            setValues(values)
        }
    }

    const handleDelete = (id) => {
        dispatch(deleteStage(id))
        setCurrentlyDeletingStageName(null)
        setCurrentlyDeleting(null)
    }

    const afterAddAndEdit = () => {
        fetchStages()
        resetModal()
    }

    //Modal handling
    const setFormula = (formula) => {
        setFieldValue('formula', formula.value)
    }

    const setRangeMode = (rangeMode) => {
        setFieldValue('rangeMode', rangeMode.value)
    }

    const addVariable = (e, index, val, touch, err) => {
        e.preventDefault()

        if (val.length > 0 && val[index].key === '' && val[index].value === '')
            return

        const vals = {
            key: '',
            value: ''
        }
        const touched = {
            key: false,
            value: false
        }
        const errs = {
            key: '',
            value: ''
        }

        val?.splice(index + 1, 0, vals)
        touch?.splice(index + 1, 0, touched)
        err?.splice(index + 1, 0, errs)

        setFieldValue('assign', val)
        setFieldTouched('assign', touch)
        setFieldError('assign', err)
    }

    const removeVariable = (e, index, vals, touchs, errs) => {
        e.preventDefault()

        vals?.splice(index, 1)
        touchs?.splice(index, 1)
        errs?.splice(index, 1)

        setFieldValue('assign', vals)
        setFieldTouched('assign', touchs)
        setFieldError('assign', errs)
    }

    const handleDeleteModal = (row) => {
        let name = row.su_stage_name && JSON.parse(row.su_stage_name)
        name = name && name[language_code]
        let id = row.su_survey_stages_id
        setCurrentlyDeletingStageName(name)
        setCurrentlyDeleting(id)
    }

    // Decode HTML entities for CKEditor without stripping tags (e.g. &lt;a&gt; → <a>)
    const prepareEditorHtml = (input) => {
        if (!input) return '';
        const textArea = document.createElement("textarea");
        textArea.innerHTML = input;
        return textArea.value;
    }

    //Sorting
    const sortString = (a, b) => {
        a = a.toLowerCase()
        b = b.toLowerCase()

        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    }

    //==> Effects <== 
    useEffect(() => {
        if (survey_id) {
            fetchFormula()
            fetchCustomVariable()
            fetchStages()
            dispatch(getTokenData(setuserId))
        }
    }, [survey_id, userId])


    //==> Memo <==
    const formulaOptions = useMemo(() => {
        const tmpOptions = customFormulas?.map((formula) => {
            return {
                value: formula.su_name,
                name: formula.su_name
            }
        })
        return tmpOptions ?? []
    }, [customFormulas])

    const variableOptions = useMemo(() => {
        const sortedVariables = [...(customVariables ?? [])].sort(
            (a, b) => (b.su_custom_variable_id ?? 0) - (a.su_custom_variable_id ?? 0)
        )
        return sortedVariables.map((variable) => ({
            value: variable.su_name,
            name: variable.su_name
        }))
    }, [customVariables])


    return (
        <>
            <div className='d-flex flex-column main-outer-wrapper main-site-wrapper language-page bg-white'>
                <SurveyListHeader />
                <div className="flex-grow-1 d-flex survey-main-wrapper">
                    <SurveyListSidebar />

                    <div id="content" className="flex-grow-1 dashboard-page-outer d-flex flex-column">
                        <SubHeader />
                        <div className="d-flex variable-pg-wrapper flex-grow-1">
                            <VariableSidebar />
                            <div className="flex-grow-1 variable-pg-content">
                                <div className="survey-main-container">
                                    <div className="page-content-wrap variables-main-container p-0">
                                        <div className="main-sec-wrap" >
                                            <div className="page-heading">
                                                {/* breadcrumbs here */}
                                                <nav aria-label="breadcrumb">
                                                    <ol className="breadcrumb">
                                                        <li className="breadcrumb-item"><Link to="/admin/survey/list">{t('survey.title')}</Link></li>
                                                        <li className="breadcrumb-item"><Link to={`/admin/survey/create/qa-builder?survey_id=${survey_id}`}>{survey_name}</Link></li>
                                                        <li className="breadcrumb-item"><Link to={`/admin/survey/create/lead-gen-variables?survey_id=${survey_id}`}>{t('survey.variable.heading')}</Link></li>
                                                        <li className="breadcrumb-item active" aria-current="page"><strong>{t('survey.stages.title')}</strong></li>
                                                    </ol>
                                                </nav>
                                                {/* breadcrumbs ends here */}
                                                <div className="d-flex align-items-start">
                                                    <div className="mt-2">
                                                        <NestedMenuToggle />
                                                    </div>
                                                    <div className="flex-grow-1 ps-3 ps-lg-0">
                                                        <h1 className="mb-0 mb-lg-3">{t('survey.stages.title')}</h1>
                                                        <p>{t('survey.stages.text')}</p>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="varTable mt-4">
                                                <div className="custom-data-table">
                                                    <DataTable
                                                        columns={columns}
                                                        data={stages ?? []}
                                                    />
                                                </div>
                                                {window.modulePermissions.M15.add == 1 && (<button type="button" className="btn btn-primary add-btn" srno="1" value="1" onClick={() => setIsVisibleModal(true)}><Svg name="plus" /> {t('survey.stages.add')} </button>)}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className={`customvar-modal modal fade edit-pop-modal ${isVisibleModal ? 'show' : ''}`} style={{ display: `${isVisibleModal ? 'block' : 'none'}` }} id="editPins" tabIndex={-1} aria-labelledby="editModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered modal-xl">
                    <div className="modal-content">
                        <div className="modal-body">
                            <form onSubmit={(e) => { if (!canMutate) { e.preventDefault(); return; } handleSubmit(e); }}>
                                <div className={"formcontainer"}>
                                    <div className={"formvawrapper" + " " + style.wrapper}>
                                        <Card view="raised" className={"formstyle p-4" + " " + style.card} >
                                            <Typography
                                                type={device === "mobile" ? "h6" : "h5"}
                                                colorStep={100}
                                                tagName="div"
                                                className={"formhead "}
                                            >
                                                {isEditMode ? t('survey.stages.edit') : t('survey.stages.add')}
                                            </Typography>

                                            <div className="form-field-wrapper">
                                                <div className="mt-5">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <div className="form-group mb-4 stage-name">
                                                                <label htmlFor="">{t('survey.stages.stagesName')}<span className="text-primary">*</span></label>
                                                                <div className="position-relative">

                                                                    <Input
                                                                        className={"formsinput" + " " + style.card__exp}
                                                                        type="text"
                                                                        view="outlined"
                                                                        color="default"
                                                                        label=""
                                                                        fill
                                                                        placeholder={t('survey.stages.stagesName')}
                                                                        value={values.stageName}
                                                                        name='stageName'
                                                                        readOnly={!canMutate}
                                                                        onChange={canMutate ? handleChange : undefined}
                                                                        onBlur={handleBlur}
                                                                    />
                                                                    {touched.stageName && errors.stageName && <div className="validation-msg"> {errors.stageName}</div>}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                {/* <div className="mt-4 selectable-field">
                                                <CreatableSelect
                                                    isClearable
                                                    options={options}
                                                />
                                            </div> */}
                                                <div className="mb-4">
                                                    <div className="d-flex align-items-center range-wrapper range-wrapper-custom">
                                                        <p>{t('survey.stages.if')} </p>
                                                        <div className="dropdown table-dropdown ques-options position-relative flex-grow-1 first-drop-formula">
                                                            <button className="btn dropdown-tgl" type="button" id="quesoptions" data-bs-toggle={canMutate ? "dropdown" : undefined}
                                                                aria-haspopup="true" aria-expanded="false" disabled={!canMutate} onClick={() => setFieldTouched('formula', true)}>
                                                                <b>{values.formula ? values.formula === '' ? 'Formula Name' : values.formula : 'Formula Name'}</b>
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="quesoptions">
                                                                {
                                                                    formulaOptions && formulaOptions.map((opt, index) => {
                                                                        return (
                                                                            <span className="dropdown-item" onClick={() => canMutate && setFormula(opt)} key={index}>{opt.name ?? ''}</span>
                                                                        )
                                                                    })
                                                                }
                                                            </div>
                                                            {touched.formula && errors.formula && <div className="validation-msg">{errors.formula ?? ''}</div>}
                                                        </div> {t('survey.stages.ranges')}
                                                        <div className="dropdown table-dropdown ques-options position-relative flex-grow-1">
                                                            <button className="btn dropdown-tgl" type="button" id="quesoptions" data-bs-toggle={canMutate ? "dropdown" : undefined}
                                                                aria-haspopup="true" aria-expanded="false" disabled={!canMutate} onClick={() => setFieldTouched('rangeMode', true)}>
                                                                <b>{values.rangeMode ? values.rangeMode === '' ? 'Range' : values.rangeMode : 'Range'}</b>
                                                            </button>
                                                            <div className="dropdown-menu" aria-labelledby="quesoptions">
                                                                {
                                                                    rangeModeOptions && rangeModeOptions.map((opt, index) => (<span key={index} className="dropdown-item" onClick={() => canMutate && setRangeMode(opt)}>{opt.name}</span>))
                                                                }
                                                            </div>
                                                            {touched.rangeMode && errors.rangeMode && <div className="validation-msg">{errors.rangeMode ?? ''}</div>}
                                                        </div>
                                                        <div className="position-relative flex-grow-1">
                                                            <Input
                                                                className={"formsinput range-input" + " " + style.card__exp}
                                                                type="number"
                                                                view="outlined"
                                                                color="default"
                                                                label=""
                                                                fill
                                                                placeholder={t('survey.stages.enter1')}
                                                                value={values.rangeStart}
                                                                name='rangeStart'
                                                                readOnly={!canMutate}
                                                                onChange={canMutate ? handleChange : undefined}
                                                                onBlur={handleBlur}
                                                            />
                                                            {touched.rangeStart && errors.rangeStart && <div className="validation-msg">{errors.rangeStart ?? ''}</div>}
                                                        </div>
                                                        <p className="px-2">{t('survey.stages.and')}</p>
                                                        <div className="position-relative flex-grow-1">
                                                            <Input
                                                                className={"formsinput range-input" + " " + style.card__exp}
                                                                type="number"
                                                                view="outlined"
                                                                color="default"
                                                                label=""
                                                                fill
                                                                placeholder={t('survey.stages.enter2')}
                                                                value={values.rangeEnd}
                                                                name='rangeEnd'
                                                                readOnly={!canMutate}
                                                                onChange={canMutate ? handleChange : undefined}
                                                                onBlur={handleBlur}
                                                            />
                                                            {touched.rangeEnd && errors.rangeEnd && <div className="validation-msg">{errors.rangeEnd ?? ''}</div>}
                                                        </div>
                                                    </div>
                                                </div>
                                                {
                                                    values?.assign?.map((obj, index) => {
                                                        return (
                                                            <div className="mb-4" key={index}>
                                                                <div className="d-lg-flex align-items-start range-wrapper custom-range range-wrapper-custom" key={index}>
                                                                    <div className="d-flex align-items-center">
                                                                        <p>{t('survey.stages.then')}</p>
                                                                        <div className="dropdown table-dropdown ques-options position-relative flex-grow-1 first-drop-formula">
                                                                            <button
                                                                                className="btn dropdown-tgl"
                                                                                type="button" id="quesoptions"
                                                                                data-bs-toggle={canMutate ? "dropdown" : undefined}
                                                                                aria-haspopup="true"
                                                                                aria-expanded="false"
                                                                                disabled={!canMutate}
                                                                                onClick={() => setFieldTouched(`assign.${index}.key`, true)}
                                                                            >
                                                                                <b>{obj.key ? obj.key : 'Custom Variable'}</b>
                                                                            </button>
                                                                            <div className="dropdown-menu stage-variable-dropdown" aria-labelledby="quesoptions">
                                                                                {
                                                                                    variableOptions && variableOptions.map((variable, i) => (
                                                                                        <span
                                                                                            key={i}
                                                                                            className="dropdown-item"
                                                                                            onClick={() => canMutate && setFieldValue(`assign.${index}.key`, variable.value)}>
                                                                                            {variable.name}
                                                                                        </span>
                                                                                    ))
                                                                                }
                                                                            </div>
                                                                            {touched.assign?.length > 0 && touched.assign[index]?.key && errors.assign?.length > 0 && errors.assign[index]?.key && <div className="validation-msg">{errors.assign[index]?.key}</div>}
                                                                        </div>
                                                                    </div>
                                                                    <div className="d-flex add-rem ck-editor-wrap align-items-start position-relative">
                                                                        <div style={{ flex: 1, pointerEvents: canMutate ? 'auto' : 'none', opacity: canMutate ? 1 : 0.85 }}>
                                                                        <CKEditor
                                                                            key={index}
                                                                            editor={ClassicEditor}
                                                                            data={prepareEditorHtml(values.assign[index]?.value)}
                                                                            config={{
                                                                                removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed", "Table", "TableToolbar"]
                                                                            }}
                                                                            onReady={editor => {
                                                                                // console.log('Editor is ready to use!', editor);
                                                                            }}
                                                                            onChange={(event, editor) => {
                                                                                if (!canMutate) return;
                                                                                setFieldValue(`assign.${index}.value`, editor.getData())
                                                                            }}
                                                                            onBlur={(event, editor) => {
                                                                                setFieldTouched(`assign.${index}.value`, true)
                                                                            }}
                                                                        />
                                                                        </div>
                                                                        <button type="button" className="butn add" disabled={!canMutate} onClick={(e) => addVariable(e, index, values.assign, touched.assign, errors.assign)}>
                                                                            <Svg name="add-circle" />
                                                                        </button>
                                                                        <button type="button" className="butn remove" disabled={!canMutate} onClick={(e) => removeVariable(e, index, values.assign, touched.assign, errors.assign)}>
                                                                            <Svg name="remove-circle" />
                                                                        </button>
                                                                        {touched.assign?.length && touched.assign[index]?.value && errors.assign?.length > 0 && errors.assign[index]?.value && <div className="validation-msg">{errors.assign[index]?.value}</div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }

                                            </div>

                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered" onClick={() => resetModal()}>{t('survey.customVariable.cancel')}</button>
                                                <button type="submit" className="btn btn-primary ms-3" disabled={!canMutate}>{isEditMode ? t('survey.stages.update') :t('survey.stages.add') }  {t('survey.stages.title')}</button>
                                            </div>
                                        </Card>
                                    </div >
                                </div >
                            </form>
                        </div>
                    </div>
                </div >
            </div >

            <div className="customvar-modal modal custom-modal fade deleteModal" id="deleteStageModal" tabIndex={-1} aria-labelledby="deleteModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer" + " " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm" + " " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0" + " " + style.card} >
                                        <div className="delete-body-wrap delete-language">
                                            <div className="heading">
                                                <h3>{t('survey.stages.del')}</h3>
                                                <p> {t('survey.customVariable.del1')} <strong>{currentlyDeletingStageName ?? ''}</strong> {t('survey.customVariable.permanently')} </p>
                                            </div>

                                            <div className="button-wrap d-flex justify-content-end">
                                                <button type="button" className="btn btn-bordered" data-bs-dismiss="modal" onClick={() => setCurrentlyDeleting(null)}>{t('survey.customVariable.cancel')}</button>
                                                {window.modulePermissions.M15.del == 1 && (<button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" onClick={() => handleDelete(currentlyDeleting)}>{t('survey.customVariable.confirm_delete')}</button>)}
                                            </div>
                                        </div>
                                    </Card>
                                </div >
                            </div >
                        </div>
                    </div>
                </div>
            </div>

            <div className={`modal-backdrop fade ${isVisibleModal ? 'show' : ''}`} style={{ display: `${isVisibleModal ? 'block' : 'none'}` }}></div>
        </>
    )
}
